/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, { ReactNode } from 'react';

import { ISocialShareViewProps } from '@msdyn365-commerce-modules/social-share/src/modules/social-share/./social-share';
import { FaShareAlt } from 'react-icons/fa';
import { SOCIAL_SHARE } from '../../../utilities/constants';
import { getToggleLang, getUserPrefLang, getUserPreferredLanguage } from '../../../utilities/language-change';
import { ISocialShareProps } from '../definition-extensions/social-share.ext.props.autogenerated';

export const SocialShareView: React.FC<ISocialShareViewProps & ISocialShareProps<{}>> = props => {
    const { SocialShareList, SocialShareItemElements, SocialShareItem, SocialShare, resources, context, config } = props;

    // Identifying Language
    const toggleLang = getToggleLang(context);
    const userPrefLang = getUserPrefLang(context.request.user.customerAccountNumber as any, context);
    const preferredLanguage: any = getUserPreferredLanguage(config.siteName as any, SOCIAL_SHARE, userPrefLang, toggleLang, context);
    const shareResourceText = preferredLanguage === 'maori' ? resources.shareResourcesTextInMaori : resources.shareResourcesText;

    if (SocialShareItemElements.length === 0) {
        props.context.telemetry.error('Social media list is empty, module wont render');
        return null;
    }
    return (
        <Module {...SocialShare}>
            <div className='ms-social-share-label'>
                <span className='ms-social-share-text'>{shareResourceText}</span>
                <span className='ms-social-share-icon moe-icon-share'>
                    <FaShareAlt title={shareResourceText}></FaShareAlt>
                </span>
            </div>
            <Node {...SocialShareList}>
                {SocialShareItemElements.map((SocialShareElement: ReactNode, index: number) => {
                    return (
                        <Node {...SocialShareItem} key={index}>
                            {SocialShareElement}
                        </Node>
                    );
                })}
            </Node>
        </Module>
    );
};

export default SocialShareView;
